(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vorair-bundle"] && !Shopify.designMode) return;
  try {
    /* Built at runtime so this file stays pure ASCII. */
  const SEP = ' ' + String.fromCharCode(183) + ' ';
  /* Drives the product form's quantity from the selected offer, and keeps the
     summary line in step. Every string it swaps in was formatted by Liquid, so
     there is no client-side money maths to drift out of sync. */
  class VorairBundle extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        if (e.target instanceof HTMLInputElement && e.target.type === 'radio') this.apply();
      });

      /* A variant change re-renders the buy box, which resets the quantity
         input and discards the price caption. Re-assert the chosen offer so
         the selector and the form cannot disagree. Guarded against the
         quantity event this class dispatches itself, and apply() only writes
         when the value actually differs, so there is no feedback loop. */
      const form = this.form;
      if (form && form !== this) {
        form.addEventListener('change', (e) => {
          if (this.contains(e.target)) return;
          if (e.target && e.target.name === 'quantity') return;
          setTimeout(() => this.apply(), 250);
        });
      }

      this.apply();
    }

    get form() {
      return this.closest('product-form-component') || document.querySelector('product-form-component');
    }

    apply() {
      const picked = this.querySelector('input[type="radio"]:checked');
      if (!picked) return;
      const qty = parseInt(picked.value, 10);
      if (!Number.isFinite(qty) || qty < 1) return;

      const root = this.form;
      if (root) {
        const input = root.querySelector('input[name="quantity"]');
        if (input && input.value !== String(qty)) {
          input.value = String(qty);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      const total = this.dataset['total' + qty];
      const save = this.dataset['save' + qty];
      const row = picked.closest('.vor-bd__opt');
      const nameEl = row ? row.querySelector('.vor-bd__n') : null;
      const label = nameEl ? nameEl.textContent.trim() : '';
      if (!total) return;

      this.caption(qty, total);

      const sum = this.querySelector('[data-vor-sum-text]');
      if (!sum) return;
      sum.innerHTML = '';
      sum.append(label + SEP);
      const b = document.createElement('b');
      b.textContent = total;
      sum.append(b);
      if (save) sum.append(SEP + 'you save ' + save);
    }

    /* The headline price is a per-unit figure. At qty 1 that is also what you
       pay, so it stands alone. Above qty 1 it would be the largest number on
       screen while not being the amount charged, so it gets qualified here.

       Deliberately fail-safe: if Horizon re-renders the price element it drops
       this caption, leaving a correct unqualified unit price rather than a
       stale total. It is re-applied on the next interaction. */
    caption(qty, total) {
      const unit = this.dataset.total1;
      const hosts = document.querySelectorAll('[id$="__main"] product-price, [data-testid="sticky-price-display"]');
      hosts.forEach((host) => {
        let cap = host.querySelector('.vor-bd__each');
        if (qty < 2) {
          if (cap) cap.remove();
          return;
        }
        if (!cap) {
          cap = document.createElement('span');
          cap.className = 'vor-bd__each';
          host.append(cap);
        }
        cap.innerHTML = '';
        cap.append(unit + ' each' + SEP + qty + ' for ');
        const b = document.createElement('b');
        b.textContent = total;
        cap.append(b);
      });
    }
  }

  if (!customElements.get('vorair-bundle')) {
    customElements.define('vorair-bundle', VorairBundle);
  }
  } catch(e) { console.error(e); }
})();

})();
